// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3MwS7","title":"AfterBackImages_title__1e6LK","images":"AfterBackImages_images__1EOXV"};